import React, { useState } from 'react'
import Modal from '../../components/modal/modal'
import { Grid } from '@material-ui/core'
import Input from '../../components/inputs/input-simple'
import SelectInput from '../../components/inputs/select'

export default function Filter(props) {
  const { changeFilter, dialogClose, open, startDate: sDate, endDate: eDate, invoiceType: iType, showInvoiceType = false, dataCy = '' } = props

  const [startDate, setStartDate] = useState(sDate)
  const [endDate, setEndDate] = useState(eDate)
  const [invoiceType, setInvoiceType] = useState(iType || 'ALL')

  return (
    <Modal
      open={open}
      onClose={dialogClose}
      fullWidth={true}
      maxWidth='md'
      modalHeading='Filter by Invoice Date'
      modalSaveTxt='Apply Filter'
      modalCloseTxt='Cancel'
      onClick={() => changeFilter(startDate, endDate, invoiceType)}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
      data-cy={dataCy || props['data-cy'] || 'date-filter-modal'}
    >
      <Grid container>
        <Grid xs={6} item className="subtaskrow-1" style={{ margin: "10px 0" }}>
          <Grid container>
            <Grid xs={3} item style={{ display: "flex", alignItems: "center" }}><p style={{ margin: "0px" }}>Invoice Date From:</p></Grid>
            <Grid xs={6} item>
              <Input
                name={'startDate'}
                label={'Start Date'}
                type={'datepicker'}
                value={startDate}
                clearable={true}
                format={'dd/MM/yyyy'}
                maxDate={endDate || null}
                maxDateMessage={'Start Date should be before End Date!'}
                onChange={(e) => setStartDate((e))}
                dataCy="start-date"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={6} item className="subtaskrow-1" style={{ margin: "10px 0" }}>
          <Grid container>
            <Grid xs={3} item style={{ display: "flex", alignItems: "center" }}><p style={{ margin: "0px" }}>Invoice Date To:</p></Grid>
            <Grid xs={6} item>
              <Input
                name={'endDate'}
                label={'End Date'}
                type={'datepicker'}
                value={endDate}
                clearable={true}
                format={'dd/MM/yyyy'}
                minDate={startDate || null}
                minDateMessage={'End Date should be after Start Date!'}
                onChange={(e) => setEndDate((e))}
                dataCy="end-date"
              />
            </Grid>
          </Grid>
        </Grid>
        {showInvoiceType && (
        <Grid xs={6} item className="subtaskrow-1" style={{ margin: "10px 0" }}>
          <Grid container>
            <Grid xs={3} item style={{ display: "flex", alignItems: "center" }}><p style={{ margin: "0px" }}>Invoice Type: </p></Grid>
            <Grid xs={6} item>
              <SelectInput
                name={'invoiceType'}
                label={'Invoice Type'}
                value={invoiceType}
                data-cy="invoice-type-select"
                onChange={(e) => setInvoiceType(e.target.value)}
                items={[
                  { value: 'ALL', key: 'All' },
                  { value: 'Regular', key: 'Regular' },
                  { value: 'Credit', key: 'Credit' }
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
        )}
      </Grid>
    </Modal>
  )
}
